var React = require('react');

function Website (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,17 C3.581722,17 0,13.418278 0,9 C0,4.581722 3.581722,1 8,1 C12.418278,1 16,4.581722 16,9 C16,13.418278 12.418278,17 8,17 Z M1.649515,9.8 C1.93393439,12.0808614 3.41856035,13.9889937 5.45144861,14.8724528 C4.69713571,13.5267382 4.14998052,11.6894031 4.02640315,9.8 L1.649515,9.8 L1.649515,9.8 Z M1.649515,8.2 L4.02576592,8.2 C4.14663645,6.30845285 4.68310865,4.47854537 5.4301115,3.13686638 C3.40817685,4.02437527 1.93293836,5.92712613 1.649515,8.2 Z M14.350485,8.2 C14.0670616,5.92712613 12.5918232,4.02437527 10.5698885,3.13686638 C11.3168913,4.47854537 11.8533636,6.30845285 11.9742341,8.2 L14.350485,8.2 Z M10.5485514,14.8724528 C12.5814397,13.9889937 14.0660656,12.0808614 14.350485,9.8 L11.9735968,9.8 C11.8500195,11.6894031 11.3028643,13.5267382 10.5485514,14.8724528 Z M6.66063762,13.7348728 C7.17987142,14.7787108 7.78856759,15.4 8,15.4 C8.21143241,15.4 8.82012858,14.7787108 9.33936238,13.7348728 C9.89527148,12.6173048 10.2686163,11.2385328 10.3713349,9.8 L5.62866515,9.8 C5.73138371,11.2385328 6.10472852,12.6173048 6.66063762,13.7348728 Z M6.64671838,4.26291654 C6.09745494,5.37571765 5.72910108,6.75618709 5.62807579,8.2 L10.3719242,8.2 C10.2708989,6.75618709 9.90254506,5.37571765 9.35328162,4.26291654 C8.83592639,3.21476106 8.2304592,2.6 8,2.6 C7.7695408,2.6 7.16407361,3.21476106 6.64671838,4.26291654 Z"}));
}

Website.displayName = "Website";

Website.defaultProps = {"viewBox":"0 0 19 19","version":"1.1"};

module.exports = Website;

Website.default = Website;



//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/assets/icons/website.svg
// module id = 4326
// module chunks = 14